export default "__VITE_ASSET__D3Kntj13__"